import { types } from 'mobx-state-tree'
import { MasteryDistributionStat } from './MasteryDistributionStat'

export const TopicMasteryDistributionStat = MasteryDistributionStat.named(
  'TopicMasteryDistributionStat',
).props({
  topic_id: types.number,
})
